var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('module-card',[_c('p',{staticClass:"text-h6 text-center"},[_vm._v("Set Up MyPEEPS Profile")]),_c('p',[_vm._v("First, we’ll set you up to use the app. This will take a few moments.")])])}
var staticRenderFns = []

export { render, staticRenderFns }